<script>
    import TipoDeJornada from "./TipoDeJornada.svelte";
    import {flip} from 'svelte/animate';
    import {scale} from 'svelte/transition';

    export let tiposDeJornada;
</script>

<style>
    ul {
        --anchoMinimo: calc(var(--ancho) / 4 - var(--padding-global));
        margin: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--anchoMinimo), 1fr));
        grid-gap: var(--padding-global);
    }

    li {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    :global(.parrillaDeTipos .caja, .parrillaDeTipos .tipoDeJornada) {
        height: 100%;
    }

    :global(.parrillaDeTipos .contenido) {
        min-height: calc(var(--alto-de-linea) * 3em);
    }
</style>

<div class="parrillaDeTipos">
    <div class="inner">
        <ul>
            {#each tiposDeJornada as tipo (tipo.id)}
                <li animate:flip={{duration: 100}} transition:scale|local={{duration: 100}}>
                    <TipoDeJornada {tipo} on:eliminar-tipo />
                </li>
            {/each}
        </ul>
    </div>
</div>